import PropTypes from 'prop-types';
import React from 'react';
import Styles from './DomElements.scss';

const SelectOption = (props) => {
    const { id, text, onClick, parentRef } = props;

    const handleClick = () => {
        onClick();
        parentRef.current.closeMenu();
    };

    return (
        <option id={id} onClick={handleClick} className={Styles.selectOption}>
            {text}
        </option>
    );
};

SelectOption.propTypes = {
    id: PropTypes.string,
    text: PropTypes.string,
    parentRef: PropTypes.any,
    onClick: PropTypes.func,
};
export default SelectOption;
